import { render } from "./Ticket.vue?vue&type=template&id=5ed7f22e"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5ed7f22e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ed7f22e', script)) {
    api.reload('5ed7f22e', script)
  }
  
  module.hot.accept("./Ticket.vue?vue&type=template&id=5ed7f22e", () => {
    api.rerender('5ed7f22e', render)
  })

}

script.__file = "src/icons/components/filled/Ticket.vue"

export default script